import KardiaRxPatientResult from './KardiaRxPatientResult';

export default KardiaRxPatientResult;



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxPatientResult/index.js